/**
 * Supports placement of overlay regions on top of the printed design to indicate where post office might
 * place labels for the recipient or sender's address information.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 * The unauthorized use of this code outside the boundaries of Opensoft is prohibited.
 *
 * @author Matt Anderson <matt.anderson@opensoftdev.com>
 */

define(
    [
        'jquery',
        'underscore',
        'assets/js/modules/designFacePreview/model/designFacePreviewModel',
        'assets/js/modules/product/model/attributeModel',
        'assets/js/modules/option/optionModel',
        'assets/js/modules/option/optionValueModel',
        'assets/js/modules/designFacePreview/abstractRenderer',
        'assets/js/modules/designFacePreview/mailingServicesGuides/view/rectangularView'
    ],
    function($, _, DesignFacePreviewModel, AttributeModel, OptionModel, OptionValueModel, abstractRenderer, RectangularView) {
        return _.extend({}, abstractRenderer, {
            selectorClassName: 'mailing-services-guides',

            defaultOptions: {
                // shading
                overlayZones: {
                    background: 'rgba(89,62,133,.5)', // lilac shade
                    strokeColor: 'rgba(188,188,188,.5)', // subtle thin stroke
                    strokeWidth: 1 // subtle thin stroke
                }
            },

            /**
             * @param {DesignFacePreviewModel} model
             * @param $target
             * @param {number} face
             */
            render: function(model, $target, face) {
                if (
                    model.hasOptionValue(OptionModel.NAME_MAILING_SERVICE, OptionValueModel.NAME_MAILING_SERVICE) &&
                    face === DesignFacePreviewModel.PAGE.BACK
                ) {
                    var options = _.defaults(model.get('mailingServicesGuidesOptions') || {}, this.defaultOptions);
                    this._createView(model, $target, options);
                }
            },

            _createView: function(model, $target, options) {
                var ViewClass = this._getViewClass(model);

                var $el = $target.find('.' + this.selectorClassName);
                if (!$el.length) {
                    $el = $('<canvas>').addClass(this.selectorClassName);
                    $target.prepend($el);
                }

                return new ViewClass({
                    model: model,
                    options: options,
                    el: $el
                });
            },

            /**
             * @param {DesignFacePreviewModel} model
             * @returns {AbstractView}
             */
            _getViewClass: function(model) {
                // presume that mailing services are always rectangular shaped
                return RectangularView;
            }
        });
    }
);
